import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const hasPast = (state: RootState) => state.pages.editor.documents.past.length > 1;

const getCanUndo = createSelector([hasPast], (canUndo) => canUndo);

export default getCanUndo;
